import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ModalsControlService} from '../../../../services/modals-control.service';
import {ModalCommand} from '../../../../types/ModalCommand';
import {ModalTypeEnum} from '../../../../enums/ModalEnums';
import {WPPostGuideLink} from '../../../../types/WPPostGuideLink';
import {MediaSizeEnum} from 'src/app/enums/WPEnums';
import {GaPreffixEnum} from '../../../../enums/AdEnums';
import {ToolsService} from '../../../../services/tools.service';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';

@Component({
  selector: 'app-boxed-link',
  templateUrl: './boxed-link.component.html',
  styleUrls: ['./boxed-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoxedLinkComponent implements OnInit {
  @Input() linkData: WPPostGuideLink;
  @Input() index: number;
  public mediaSizeEnum = MediaSizeEnum;
  public gaPreffixEnum = GaPreffixEnum;
  public btnClass: string;
  protected readonly DLPageTypeEnum = DLPageTypeEnum;

  constructor(
    private modalControl: ModalsControlService,
    private tools: ToolsService,
  ) {}

  ngOnInit() {
    this.setBtnClass();
  }

  public openModal(): void {
    const modalCommand: ModalCommand = {
      type: ModalTypeEnum[this.linkData.acf.openModal],
      data: null,
    };
    this.modalControl.openModal(modalCommand);
  }

  private setBtnClass(): void {
    this.btnClass = !this.tools.isNil(this.index) ? `test-boxed-link-btn-${this.index}` : `test-boxed-link-btn`;
  }
}
